<template>
  <div id="nav">
      <router-view/>
  </div>
</template>

<style lang="less">
    #nav,#app {
        width: 100%;
        height: 100%;
    }
    #nav{
        position: relative;
    }
</style>
